import { gql } from 'graphql.macro';

export const scannerCaseListItemFragment = gql`
    fragment scannerCaseListItemFields on ScannerCase {
        _id
        displayCaseId
        version
        source
        orderStatus
        externalSourceStatus
        patient {
            firstName
            lastName
            patientRefNo
        }
        dentist {
            externalId
            name
        }
        clinic {
            externalId
            name
        }
        comments
        updatedAt
        deliveryDate
        organization {
            _id
        }
    }
`;

export const scannerCaseFragment = gql`
    fragment scannerCaseFields on ScannerCase {
        _id
        caseId
        displayCaseId
        version
        source
        orderStatus
        externalSourceStatus
        patient {
            firstName
            lastName
            patientRefNo
        }
        dentist {
            externalId
            name
            email
        }
        clinic {
            externalId
            name
        }
        comments
        updatedAt
        deliveryDate
        restorations {
            teethNumbers
            product
            material
            shade
        }
    }
`;

export const scannerCaseDetailsFragment = gql`
    fragment scannerCaseDetailsFields on ScannerCase {
        ...scannerCaseFields
        sourceFiles {
            fileSourceId
            fileName
            type
            disallowDownload
        }
        restorations {
            teethNumbers
            jaw
            product
            material
            shade
            iconUrl
        }
        fileProcessingStatus
        processedFiles {
            _id
            filename
            mimetype
            url
        }
        previewImages {
            _id
            filename
            mimetype
            url
        }
        orders {
            _id
            orderId
            status
        }
        organization {
            _id
        }
    }
    ${scannerCaseFragment}
`;

export const scannerCasePrintableOrderFormFragment = gql`
    fragment scannerCasePrintableOrderFormFields on ScannerCase {
        printableOrderForm {
            type
            file {
                _id
                filename
                mimetype
                url
            }
        }
    }
`;
